import { useCallback, useEffect, useMemo, useState } from "react"
import { UserService } from "../../../services/UserService";
import { useLocation, useNavigate } from "react-router";
import * as selector from "../../../selectors/selectors";
import { useSelector } from "react-redux";
import { setBackHandler, setHeaderTitle } from "../../../helpers/header.helper";
import { buttonLabels, IntegrationLabels, pageTitles, ToasterTexts } from "../../shared/constants";
import { AppRoutes, TeamsRoutes } from "../../routes/route.path";
import setToast from '../../../helpers/toaster.helper'
import { ToasterType } from "../../shared/toaster/toaster.model";
import { IntegrationSetupService } from "../../../services/IntegrationSetup";
import ButtonComponent from "../../shared/button/button.component";
import { app, authentication } from "@microsoft/teams-js";
import Config from "../../../config";
import { BirdLogo, ClioIcon, ClioIntRectIcon, IntegrationIcon, MicroSoftImportContacts, MicroSoftImportContactsArrow, MicroSoftImportContactsFalkon, MicrosoftImportContactsInfo } from "../../../icon";
import { LocalStorage, UtilityService } from "../../../services/UtilityService";
import { Grid, Tooltip, Typography } from "@mui/material";
import CustomSwitch from "../../shared/switch.component";

const OutlookSetUp = () => {
    const location = useLocation();
    const navigate = useNavigate()
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp);
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const IsContactSyncing = useSelector(selector.IscontactsSyncing)
    const IsDarkMode = useSelector(selector.isDarkMode)
    const [isConnected, setIsconnected] = useState<boolean>(false)
    const currentUser = useMemo(() => LocalStorage.get('current-user'), [])
    const orgRef = useMemo(() => UserService.getCurrentUserOrgRef(), [])
    const OrgId = useMemo(() => UserService.getCurrentUserOrgId(), [])
    const phoneNumberId = UserService.getUserPhoneNumberId()
    const [loading, setLoading] = useState(false)
    const [isEnabled, setIsEnabled] = useState<boolean>(false)

    //iitial rendring
    useEffect(() => {
        setHeaderTitle(pageTitles.OUTLOOK)
        setBackHandler(() => navigate(AppRoutes.INTEGRATIIONS))

        return () => {
            setBackHandler(null)
            setHeaderTitle('')
        }
    }, [])

    //when location is changed
    useEffect(() => {
        if (!!location.search) {
            const params = new URLSearchParams(location.search);
            setIsconnected(params.get('connection') === 'true')
        }
        if (isConnected) {
            setToast(ToasterTexts.OUTLOOK_CONNECTION_SUCCESS, ToasterType.SUCCESS)
        }
    }, [location?.search])

    //when connection state chagnes 
    // useEffect(() => {
    //     if (isConnected === true) {
    //         const data = {
    //             OrgId: OrgId,
    //             name: IntegrationLabels.OUTLOOK,
    //             integrationCode: IntegrationSetupService.OutlookIntigration_code,
    //             integrationStatus: isConnected
    //         }
    //         IntegrationSetupService.updateIntegrationStatus(data).then((res) => console.log(res)).catch()
    //     }
    // }, [isConnected, OrgId])

    useEffect(() => {
        IntegrationSetupService.getOutlookImportSetting().then((res) => {
            setIsEnabled(res.data.isActive)
        }).catch()
    }, [])

    const connectToOutlook = useCallback(() => {
        if (IsTeamsApp) {
            app.initialize()
            authentication.authenticate({
                url: TeamsRoutes.OUTLOOK_POPUP,
                width: 800,
                height: 600,
                successCallback: (result) => {
                    navigate(AppRoutes.OUTLOOK + `?connection=${true}`)
                },
                failureCallback: (reason) => {
                    console.error('Authentication failed:', reason);
                }
            })
        }
        else {
            window.location.href = `${Config.API_URL}/api/Outlook/Connect?OrgRef=${orgRef}&userId=${currentUser?.id}&phoneNumber=${UtilityService.unmaskPhoneNumber(currentUser?.phoneNumber)}`;
        }

    }, [IsTeamsApp, navigate, orgRef, currentUser])


    const disconnect = () => {
        IntegrationSetupService.DisConnectToOutlook().then((res) => {
            setIsconnected(false)
            navigate(AppRoutes.OUTLOOK + `?connection=${false}`)
            setToast(ToasterTexts.OUTLOOK_DISCONNECT, ToasterType.SUCCESS)
            // const data = {
            //     OrgId: OrgId,
            //     name: IntegrationLabels.OUTLOOK,
            //     integrationCode: IntegrationSetupService.OutlookIntigration_code,
            //     integrationStatus: false
            // }
            // IntegrationSetupService.updateIntegrationStatus(data).then((res) => console.log(res)).catch()

        }).catch((err) => { setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER) })
    }
    const handleSyncContacts = () => {
        setLoading(true)
        IntegrationSetupService.ImportOutlookContacts().then((res) => {
            // console.log(res)
            setLoading(false)
        }).catch((err) => {
            console.log(err)
            setLoading(false)
            setToast(err?.response?.data.message, ToasterType.DANGER)
        })
    }
    const handleswitch = (checked) => {
        setIsEnabled(checked)
        let obj = {
            "phoneNumberId": phoneNumberId,
            "frequency": 0,
            "isActive": checked,
        }
        IntegrationSetupService.UpdateOutlookImportSetting(obj).then((res) => { }).catch()
    }

    return (
        <div className={`d-flex w-p-100 h-90 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-profile-primary-background"} `}>
            <div className={`ag-theme-alpine h-p-100 w-fill m-auto ${IsMobileDevice ? "pt-1 pb-2" : `p-2 ${IsDarkMode ? "" : "bg-color-grid"} `}`}>
                <div className={`d-flex flex-direction mt-1 h-p-100 ${IsDarkMode ? "bg-color-primary-background" : "bg-color-login"} o-y-scroll`}>
                    <div className='py-2 px-4'>
                        <div className="d-flex flex-direction">
                            <div className="d-flex justify-between pb-2">
                                <span className='h3-regular color-primary' >Start importing from Outlook to  <span className='h3-bold'>FalkonSMS</span></span>
                                <div className='d-flex'>
                                    {
                                        isConnected === false ?
                                            <>
                                                <ButtonComponent ButtonLabel='Connect To Outlook' Variant={"primary-btn"} ClassName='m-0 ml-2' OnClick={connectToOutlook} />
                                            </> :
                                            <>
                                                <ButtonComponent ButtonLabel={IsContactSyncing ? buttonLabels.SYNCING : "Sync"} Variant={IsContactSyncing ? "disabled-btn" : "primary-btn"} ClassName='m-0' OnClick={handleSyncContacts} />
                                                <ButtonComponent ButtonLabel='Disconnect' Variant='secondary-btn' ClassName='m-0 ml-2' OnClick={disconnect} />
                                                <Tooltip title="If you want to import from different office account, please disconnect your old account and reconnect with new account." placement="bottom" className='align-center ml-1 mt-1'>
                                                    <MicrosoftImportContactsInfo />
                                                </Tooltip>
                                            </>
                                    }
                                </div>
                            </div>
                            <div className="d-flex justify-around import-contacts-outlook-border py-3 mb-3">
                                <MicroSoftImportContacts />
                                <MicroSoftImportContactsArrow />
                                <MicroSoftImportContactsFalkon />
                            </div>
                            <div className="pt-1">
                                <span className={`h3-medium pb-1 d-flex justify-between ${IsDarkMode ? "color-primary-btn-color" : "import-contact-title"}`}>
                                    Automatic daily sync
                                    <CustomSwitch checked={isEnabled} onChange={(checked: boolean) => handleswitch(checked)} />
                                </span>
                                <span className="h5-regular color-primary-accent">
                                    Enable automatic syncing of your contacts from Outlook to FalkonSMS every day. This will ensure your contact list is always up to date.
                                </span>
                            </div>
                            <div className="d-flex pt-1 pb-1">
                                <Typography className={`h3-medium ${IsDarkMode ? "color-primary-btn-color" : "import-contact-title"}`}>Field mappings</Typography>
                            </div>
                            <Grid className='b-around-text-field-border-4 br-2 color-primary'>
                                <Grid container className={`d-flex justify-center py-2 px-3 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-grid"} brt-2`}>
                                    <Grid item md={6}>
                                        <Typography>Outlook contacts</Typography>
                                    </Grid>
                                    <Grid item md={6}>
                                        <Typography>Falkon SMS contacts</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container className=" py-1 px-3 bb-primary-background-pink-4">
                                    <Grid item md={6}>
                                        <Typography>First Name</Typography>
                                    </Grid>
                                    <Grid item md={6}>
                                        <Typography>First Name</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container className="py-1 px-3  bb-primary-background-pink-4">
                                    <Grid item md={6}>
                                        <Typography>Last Name</Typography>
                                    </Grid>
                                    <Grid item md={6}>
                                        <Typography>Last Name</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container className="py-1 px-3  bb-primary-background-pink-4">
                                    <Grid item md={6}>
                                        <Typography>Mobile Phone Number</Typography>
                                    </Grid>
                                    <Grid item md={6}>
                                        <Typography>Phone Number</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container className="py-1 px-3  bb-primary-background-pink-4">
                                    <Grid item md={6}>
                                        <Typography>Email address</Typography>
                                    </Grid>
                                    <Grid item md={6}>
                                        <Typography>Email</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <div className='mt-2 br-1 bg-color-import-contacts-outlook-background color-primary-accent'>
                                <Typography className='h4-regular py-1 pl-3'>We will only sync contacts that have a valid phone number.</Typography>
                            </div>
                            <div className='mt-2 br-1 bg-color-import-contacts-outlook-background color-primary-accent'>
                                <Typography className='h4-regular py-1 pl-3'>While importing, we will skip the contact if the phone number is already present in the Falkon SMS contact list.</Typography>
                            </div>
                            <div className='mt-2 br-1 bg-color-import-contacts-outlook-background color-primary-accent'>
                                <Typography className='h4-regular py-1 pl-3'>By clicking Sync, you confirm that these contacts have given their consent to receive SMS messages from you.</Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div>
    )
}

export default OutlookSetUp